export default __webpack_public_path__ + "static/media/Car1.83417303.jpg";